import { getPermissions, getCurrentUserData } from '../../utils/selectors';


export default (state) => ({
  ...state.comments,
  permissions: getPermissions(state),
  currentUser: getCurrentUserData(state),
});
